import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CopiesLayer, TrashLayer, CheckboxLayer} from './';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faSpinner, faTrashAlt, faCopy, faTimes, faPrint, faExclamationTriangle, faDownload} from '@fortawesome/fontawesome-free-solid';
import { ImagesActions } from '../../../actions';

import './imageItem.scss';

class ImageItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageLoad: false,
            openLayerClass: '',
            resetCopiesLayer: false,
            data: {
                printed: false,
                _id: null,
                eventID: null,
                url: null
            },
            imageCacheUrl: false,
            showLayers: {
                trash: false,
                copies: false,
                error: false
            },
            selected: false,
            loadError: false
        }

        this.isCancelled = false;
        this.imageDOM = React.createRef();

        this.onLoad = this.onLoad.bind(this);
        this.openUpdateCopiesLayer = this.openUpdateCopiesLayer.bind(this);
        this.closeLayer = this.closeLayer.bind(this);
        this.openGoToTrashLayer = this.openGoToTrashLayer.bind(this);
        this.select = this.select.bind(this);
        this.onError = this.onError.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(!props.data) return null;

        const nextStateData = {};

        for(let p in state.data) {
            let propsVal = props.data[p];

            if(propsVal && propsVal !== state.data[p]) nextStateData[p] = propsVal;
        }

        if(Object.keys(nextStateData).length === 0) return null;

        return {
            cache: props.cache,
            onImageReady: props.onImageReady,
            data: {...state.data, ...nextStateData}
        }
    }

    componentDidMount() {
        const {cache, onImageReady} = this.props;
        const {data} = this.state;

        const noCache = () => {
            this.setState({imageCacheUrl: data.url}, () => {
                if(onImageReady) onImageReady(this.imageDOM);
            });
        }

        if(cache) {
            cache.get(data._id, data.url).then((cache) => {
                !this.isCancelled && this.setState({imageCacheUrl: cache.data}, () => {
                    if(onImageReady) onImageReady(this.imageDOM);
                });
            }).catch(noCache);
        } else {
            noCache();
        }
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    onLoad() {
        this.setState({imageLoad: true, loadError: false});
        this.closeLayer();
    }

    onError() {
        this.setState({loadError: true});
    }

    select() {
        this.setState({selected: !this.state.selected});
    }

    openUpdateCopiesLayer() {
        const showLayers = {...this.state.showLayers};
        for(let p in showLayers) showLayers[p] = false;
        showLayers.copies = true;

        this.setState({openLayerClass: 'copies', showLayers: showLayers});
    }

    openGoToTrashLayer() {
        const showLayers = {...this.state.showLayers};
        for(let p in showLayers) showLayers[p] = false;
        showLayers.trash = true;

        this.setState({openLayerClass: 'toTrash', showLayers: showLayers});
    }

    closeLayer() {
        const showLayers = {...this.state.showLayers};
        for(let p in showLayers) showLayers[p] = false;

        this.setState({openLayerClass: '', showLayers: showLayers});
    }

    download() {
        const {dispatch} = this.props;
        const {imageCacheUrl, data} = this.state;

        dispatch(ImagesActions.downloadImage(data, imageCacheUrl));
    }

    render() {
        const {data, cache} = this.props;
        const {loadError, imageLoad, openLayerClass, showLayers, imageCacheUrl} = this.state;
        
        const renderImage = () => {
            if(imageCacheUrl) return (
                <img data-src={imageCacheUrl} ref={this.imageDOM} onError={this.onError} onLoad={this.onLoad} alt=""/>
            )
        }

        return (
            <div className={`imageItem ${!imageLoad ? 'tmpHeight' : ''}`}>
                <div className={`imageLoader ${imageLoad ? 'loaded' : ''}`}>
                    <FontAwesomeIcon icon={faSpinner} spin />
                </div>
                <div className={`imageError ${loadError ? 'show': ''} ${imageLoad ? 'loaded' : ''}`}>
                    <FontAwesomeIcon icon={faExclamationTriangle}/>
                    <div className="errorMsg">
                        לא ניתן לטעון את התמונה<br />
                        אנא בדקו האם אתם מחוברים לאינטרנט
                    </div>
                    <div className="imageId">
                        {data._id}
                    </div>
                </div>
                <div className={`imageContainer ${openLayerClass}`}>
                    {renderImage()}
                    <div id="closeUpdate" onClick={this.closeLayer}>
                        <FontAwesomeIcon icon={faTimes} />
                    </div>
                    <CopiesLayer 
                        onClose={this.closeLayer}
                        copies={data.copies}
                        printed={data.printed}
                        imageID={this.state.data._id}
                        eventID={this.state.data.eventID}
                        show={showLayers.copies}
                    />
                    <TrashLayer
                        onClose={this.closeLayer}
                        copies={data.copies}
                        imageID={this.state.data._id}
                        eventID={this.state.data.eventID}
                        show={showLayers.trash}
                        cache={cache}
                    />
                    {/* <CheckboxLayer 
                        checked={this.state.selected}
                        onClick={this.select}
                    /> */}
                </div>
                <div className="imageDetails">
                    <div className="bulk">
                        <div className={`copies ${data.copies === 0 ? 'hide': ''}`} onClick={this.openUpdateCopiesLayer}>
                            <FontAwesomeIcon icon={faCopy} />&nbsp;{data.copies}
                        </div>
                        <div className={`copies ${data.copies > 0 ? 'hide': ''}`} onClick={this.openUpdateCopiesLayer}>
                            הוציאו מהפח
                        </div>
                        <div className={`print ${data.copies === 0 ? 'hide': ''}`}>
                            <FontAwesomeIcon icon={faPrint} />&nbsp;{data.printed}
                        </div>
                    </div>
                    <div className="bulk">
                        <div className="trash" onClick={this.openGoToTrashLayer}>
                            <FontAwesomeIcon icon={faTrashAlt} />&nbsp;
                        </div>
                        <div className="download" onClick={this.download.bind(this)}>
                            <FontAwesomeIcon icon={faDownload} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const ImageItemWithRedux = connect()(ImageItem);

export {ImageItemWithRedux as ImageItem};


// WEBPACK FOOTER //
// ./src/components/EventPage/images/ImageItem.jsx